/** Deterministic PRNG (mulberry32) threaded through the World seed, so the sim
 *  is reproducible and reducers stay pure. Never call Math.random in sim logic. */
export class Rng {
  seed: number;
  constructor(seed: number) {
    this.seed = seed | 0;
  }
  next(): number {
    let s = (this.seed = (this.seed + 0x6d2b79f5) | 0);
    let t = Math.imul(s ^ (s >>> 15), 1 | s);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  }
  int(n: number): number {
    return Math.floor(this.next() * n);
  }
  range(lo: number, hi: number): number {
    return lo + this.next() * (hi - lo);
  }
  pick<T>(arr: T[]): T {
    return arr[this.int(arr.length)];
  }
  weighted(weights: number[]): number {
    const total = weights.reduce((a, b) => a + b, 0);
    if (total <= 0) return -1;
    let r = this.next() * total;
    for (let i = 0; i < weights.length; i++) {
      r -= weights[i];
      if (r < 0) return i;
    }
    return weights.length - 1;
  }
}

export function seedFromTime(now: number): number {
  let h = (now ^ 0x9e3779b9) >>> 0;
  h = Math.imul(h ^ (h >>> 16), 0x45d9f3b);
  h = Math.imul(h ^ (h >>> 16), 0x45d9f3b);
  h ^= h >>> 16;
  return (h | 1) | 0;
}
